import loadable from '@loadable/component'

export default [
  // {
  //   path: '/feedback',
  //   exact: true,
  //   component: loadable(
  //     () => import(/* webpackChunkName: "page-Feedback" */ '~/pages/Feedback')
  //   ),
  // },
  {
    path: '/faq',
    exact: true,
    component: loadable(
      () => import(/* webpackChunkName: "page-FAQ" */ '~/pages/Feedback/FAQ')
    ),
  },
  {
    path: '/faq/:id',
    exact: true,
    component: loadable(
      () =>
        import(
          /* webpackChunkName: "page-FAQDetail" */ '~/pages/Feedback/FAQDetail'
        )
    ),
  },
  {
    path: '/feedback',
    exact: true,
    component: loadable(
      () =>
        import(
          /* webpackChunkName: "page-FeedbackReportScenes" */ '~/pages/Feedback/ReportScenes'
        )
    ),
  },
  {
    path: '/feedback/room',
    exact: true,
    component: loadable(
      () =>
        import(
          /* webpackChunkName: "page-FeedbackReportScenes" */ '~/pages/Feedback/ReportScenes'
        )
    ),
  },
  {
    path: '/feedback/reportcontent',
    exact: true,
    component: loadable(
      () =>
        import(
          /* webpackChunkName: "page-FeedbackReportContent" */ '~/pages/Feedback/ReportContent'
        )
    ),
  },
  {
    path: '/feedback/servicecenter',
    exact: true,
    component: loadable(
      () =>
        import(
          /* webpackChunkName: "page-FeedbackServiceCenter" */ '~/pages/Feedback/ServiceCenter'
        )
    ),
  },
  {
    path: '/feedback/servicecenter/:type',
    exact: true,
    component: loadable(
      () =>
        import(
          /* webpackChunkName: "page-FeedbackServiceCenter" */ '~/pages/Feedback/ServiceCenter'
        )
    ),
  },
  {
    path: '/feedback/illegaldetail',
    exact: true,
    component: loadable(
      () =>
        import(
          /* webpackChunkName: "page-FeedbackIllegalDetail" */ '~/pages/Feedback/IllegalDetail'
        )
    ),
  },
  {
    path: '/feedback/punishdetail',
    exact: true,
    component: loadable(
      () =>
        import(
          /* webpackChunkName: "page-FeedbackPunishDetail" */ '~/pages/Feedback/PunishDetail'
        )
    ),
  },
]
